import { booleanAttribute } from "#ce/utils/props";

// Mirrors the server-side cap, `ProviderDirectoryExport::ResultSet::MAX_ENTRIES`;
// the panel only warns, the backend enforces.
export const RECORD_CAP = 500;

export const props = Object.freeze({
  /**
   * The finder search query string, passed through verbatim. The backend re-runs
   * the search server-side to build the PDF.
   *
   * @type {String}
   * @default ""
   */
  searchParams: {
    type: String,
    default: "",
  },
  /**
   * Total number of results of the current search. Drives the record-cap warning
   * shown when it exceeds record-cap.
   *
   * @type {Number|String}
   * @default 0
   * @storybook-control number
   */
  totalCount: {
    type: [Number, String],
    default: 0,
  },
  /**
   * Maximum number of records included in the PDF.
   *
   * @type {Number|String}
   * @default 500
   * @storybook-control number
   */
  recordCap: {
    type: [Number, String],
    default: RECORD_CAP,
  },
  /**
   * Simulate the export lifecycle in the browser instead of calling the backend.
   * A bare attribute runs the happy path; a scenario name forces one flow:
   * happy, slow, failed, rate-limited, email-invalid, email-rate-limited, or
   * email-failed. For development and Storybook.
   *
   * @type {Boolean|String}
   * @default false
   */
  stubApi: booleanAttribute(),
  /**
   * Allow the page's `pdf_export_stub` query param to select a stub scenario.
   * The server renders this attribute only in development.
   *
   * @type {Boolean|String}
   * @default false
   */
  allowStubParam: booleanAttribute(),
});
